import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card d-block" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-md-8" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_8 = { "aria-label": "breadcrumb" }
const _hoisted_9 = { class: "breadcrumb mb-0" }
const _hoisted_10 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_11 = { class: "breadcrumb-item" }
const _hoisted_12 = { class: "breadcrumb-item" }
const _hoisted_13 = { class: "breadcrumb-item" }
const _hoisted_14 = { href: "javascript:void(0)" }
const _hoisted_15 = {
  key: 0,
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_16 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_17 = { class: "col-lg-4" }
const _hoisted_18 = { class: "text-lg-right" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_20 = { class: "card d-block" }
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = { class: "col-md-12" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { for: "" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { for: "" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { for: "" }
const _hoisted_31 = { class: "form-group bg-light p-3" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { for: "" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { for: "" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = { for: "" }
const _hoisted_42 = {
  key: 1,
  class: "text-center"
}
const _hoisted_43 = {
  key: 2,
  class: "form-group"
}
const _hoisted_44 = { for: "" }
const _hoisted_45 = { class: "form-group mt-3" }
const _hoisted_46 = {
  key: 0,
  for: ""
}
const _hoisted_47 = { class: "required" }
const _hoisted_48 = { key: 3 }
const _hoisted_49 = { class: "row align-items-center mb-2" }
const _hoisted_50 = { class: "col-sm-6" }
const _hoisted_51 = { class: "form-check form-check-inline mb-2" }
const _hoisted_52 = {
  for: "",
  title: "Phase Name"
}
const _hoisted_53 = { class: "col-sm-6" }
const _hoisted_54 = { class: "text-sm-right" }
const _hoisted_55 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_57 = { class: "row my-1" }
const _hoisted_58 = { class: "col-md-4" }
const _hoisted_59 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_61 = { class: "desc-wrap" }
const _hoisted_62 = { class: "col-md-4" }
const _hoisted_63 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1 green-bordered-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-check" })
], -1)
const _hoisted_65 = { class: "desc-wrap" }
const _hoisted_66 = { class: "col-md-4" }
const _hoisted_67 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_68 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1 red-bordered-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-times" })
], -1)
const _hoisted_69 = { class: "desc-wrap" }
const _hoisted_70 = { class: "mt-4" }
const _hoisted_71 = {
  key: 0,
  class: "border rounded bg-light p-3 mt-2 pb-0"
}
const _hoisted_72 = { class: "row align-items-center mb-2" }
const _hoisted_73 = { class: "col-sm-6" }
const _hoisted_74 = { class: "form-check form-check-inline mb-2" }
const _hoisted_75 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_76 = { class: "members-list pt-sm-0 text-sm-right" }
const _hoisted_77 = { class: "row my-1" }
const _hoisted_78 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_79 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_80 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_81 = { class: "desc-wrap" }
const _hoisted_82 = { class: "mt-2" }
const _hoisted_83 = { class: "mt-2" }
const _hoisted_84 = {
  key: 0,
  class: "list-accordion mt-2"
}
const _hoisted_85 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_86 = { class: "mb-0" }
const _hoisted_87 = { class: "card-body p-2" }
const _hoisted_88 = { class: "row" }
const _hoisted_89 = { class: "col-md-6" }
const _hoisted_90 = { class: "col-md-6" }
const _hoisted_91 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_92 = {
  key: 2,
  class: "border rounded bg-light p-3 mt-2 pb-0"
}
const _hoisted_93 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_94 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_95 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_96 = { class: "sr-only" }
const _hoisted_97 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_98 = { class: "imaged-col" }
const _hoisted_99 = { class: "small-img-wrap" }
const _hoisted_100 = { class: "size" }
const _hoisted_101 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_102 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_103 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_104 = { class: "sr-only" }
const _hoisted_105 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_106 = { class: "imaged-col" }
const _hoisted_107 = { class: "small-img-wrap" }
const _hoisted_108 = { class: "size" }
const _hoisted_109 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_110 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_111 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_112 = { class: "sr-only" }
const _hoisted_113 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_114 = { class: "imaged-col" }
const _hoisted_115 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_116 = { class: "size" }
const _hoisted_117 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_118 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_119 = { class: "centered-wrap" }
const _hoisted_120 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_121 = { class: "sr-only" }
const _hoisted_122 = { class: "size" }
const _hoisted_123 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_124 = {
  key: 4,
  class: "my-3"
}
const _hoisted_125 = { key: 5 }
const _hoisted_126 = {
  key: 6,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_127 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_128 = {
  key: 0,
  class: "company-logo-wrap border p-1 rounded my-3 bg-white"
}
const _hoisted_129 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_130 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_131 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_132 = {
  class: "nav-link active",
  id: "Contract-tab",
  "data-toggle": "tab",
  "data-target": "#Contract",
  type: "button",
  role: "tab",
  "aria-controls": "Contract",
  "aria-selected": "true"
}
const _hoisted_133 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_134 = {
  class: "nav-link",
  id: "Contract1-tab",
  "data-toggle": "tab",
  "data-target": "#Contract1",
  type: "button",
  role: "tab",
  "aria-controls": "Contract1",
  "aria-selected": "false"
}
const _hoisted_135 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_136 = {
  class: "tab-pane fade show active",
  id: "Contract",
  role: "tabpanel",
  "aria-labelledby": "Contract-tab"
}
const _hoisted_137 = {
  class: "tab-pane fade",
  id: "Contract1",
  role: "tabpanel",
  "aria-labelledby": "Contract1-tab"
}
const _hoisted_138 = { class: "inline-items mt-3" }
const _hoisted_139 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_140 = { for: "" }
const _hoisted_141 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_142 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_143 = { class: "form-group" }
const _hoisted_144 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_145 = { class: "form-group" }
const _hoisted_146 = { class: "inline-items" }
const _hoisted_147 = { class: "upload-btn-wrapper" }
const _hoisted_148 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_149 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_150 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eraser" }, null, -1)
const _hoisted_151 = { key: 0 }
const _hoisted_152 = { class: "upload-btn-wrapper" }
const _hoisted_153 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_154 = { class: "form-group" }
const _hoisted_155 = { for: "" }
const _hoisted_156 = {
  key: 0,
  class: "image-in-chat preview-image-list"
}
const _hoisted_157 = { class: "row mx-n2" }
const _hoisted_158 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_159 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_160 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_161 = { class: "sr-only" }
const _hoisted_162 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_163 = { class: "imaged-col" }
const _hoisted_164 = { class: "small-img-wrap" }
const _hoisted_165 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_166 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_167 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_168 = { class: "sr-only" }
const _hoisted_169 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_170 = { class: "imaged-col" }
const _hoisted_171 = { class: "small-img-wrap" }
const _hoisted_172 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_173 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_174 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_175 = { class: "sr-only" }
const _hoisted_176 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_177 = { class: "imaged-col" }
const _hoisted_178 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_179 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_180 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_181 = { class: "centered-wrap" }
const _hoisted_182 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_183 = { class: "sr-only" }
const _hoisted_184 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_185 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_186 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_187 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_188 = { class: "sr-only" }
const _hoisted_189 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_190 = { class: "imaged-col" }
const _hoisted_191 = { class: "small-img-wrap" }
const _hoisted_192 = { class: "size" }
const _hoisted_193 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_194 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_195 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_196 = { class: "sr-only" }
const _hoisted_197 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_198 = { class: "imaged-col" }
const _hoisted_199 = { class: "small-img-wrap" }
const _hoisted_200 = { class: "size" }
const _hoisted_201 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_202 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_203 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_204 = { class: "sr-only" }
const _hoisted_205 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_206 = { class: "imaged-col" }
const _hoisted_207 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_208 = { class: "size" }
const _hoisted_209 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_210 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_211 = { class: "centered-wrap" }
const _hoisted_212 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_213 = { class: "sr-only" }
const _hoisted_214 = { class: "size" }
const _hoisted_215 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_216 = { class: "bg-light p-2 rounded border mb-3" }
const _hoisted_217 = {
  key: 0,
  class: "row mx-n2"
}
const _hoisted_218 = {
  key: 0,
  class: "shadowed-card bg-white h-100 p-2"
}
const _hoisted_219 = { class: "row mx-n2" }
const _hoisted_220 = { class: "col-xl-6 px-2" }
const _hoisted_221 = { class: "form-group" }
const _hoisted_222 = { for: "" }
const _hoisted_223 = { class: "text-red" }
const _hoisted_224 = { class: "col-xl-6 px-2" }
const _hoisted_225 = { class: "form-group" }
const _hoisted_226 = { for: "" }
const _hoisted_227 = { class: "col-xl-6 px-2" }
const _hoisted_228 = { class: "form-group" }
const _hoisted_229 = { for: "" }
const _hoisted_230 = { class: "col-xl-6 px-2" }
const _hoisted_231 = { class: "form-group" }
const _hoisted_232 = { for: "" }
const _hoisted_233 = { class: "input-group" }
const _hoisted_234 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "+1")
], -1)
const _hoisted_235 = { class: "text-red" }
const _hoisted_236 = { class: "col-xl-6 px-2" }
const _hoisted_237 = { class: "form-group" }
const _hoisted_238 = { for: "" }
const _hoisted_239 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_240 = { class: "form-check form-check-inline" }
const _hoisted_241 = {
  class: "form-check-label",
  for: "inlineCheckbox1"
}
const _hoisted_242 = { class: "form-check form-check-inline" }
const _hoisted_243 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_244 = { class: "text-red" }
const _hoisted_245 = { class: "col-xl-6 px-2" }
const _hoisted_246 = { class: "form-group" }
const _hoisted_247 = { for: "" }
const _hoisted_248 = { class: "text-end" }
const _hoisted_249 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check-circle" }, null, -1)
const _hoisted_250 = {
  key: 1,
  class: "shadowed-card bg-white h-100 p-2"
}
const _hoisted_251 = { class: "text-end" }
const _hoisted_252 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt" }, null, -1)
const _hoisted_253 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_254 = { class: "row mx-n2" }
const _hoisted_255 = { class: "col-xl-6 px-2" }
const _hoisted_256 = { class: "mb-3" }
const _hoisted_257 = { class: "col-xl-6 px-2" }
const _hoisted_258 = { class: "mb-3" }
const _hoisted_259 = { class: "col-xl-6 px-2" }
const _hoisted_260 = { class: "mb-3" }
const _hoisted_261 = { class: "col-xl-6 px-2" }
const _hoisted_262 = { class: "mb-3" }
const _hoisted_263 = { class: "col-xl-6 px-2" }
const _hoisted_264 = { class: "mb-3" }
const _hoisted_265 = { key: 0 }
const _hoisted_266 = /*#__PURE__*/_createTextVNode("       ")
const _hoisted_267 = { key: 1 }
const _hoisted_268 = { class: "col-xl-6 px-2" }
const _hoisted_269 = { class: "mb-3" }
const _hoisted_270 = {
  key: 1,
  class: "alert alert-warning text-center",
  role: "alert"
}
const _hoisted_271 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle me-1" }, null, -1)
const _hoisted_272 = { class: "form-group" }
const _hoisted_273 = { for: "" }
const _hoisted_274 = {
  key: 7,
  class: "form-check form-check-inline mb-2"
}
const _hoisted_275 = { class: "form-check form-check-inline mb-2" }
const _hoisted_276 = { class: "form-group mt-3" }
const _hoisted_277 = {
  key: 0,
  for: ""
}
const _hoisted_278 = { class: "required" }
const _hoisted_279 = { class: "modal-wrap default-modal" }
const _hoisted_280 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: -1,
  "aria-labelledby": "showPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_281 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_282 = { class: "modal-content" }
const _hoisted_283 = { class: "modal-header" }
const _hoisted_284 = {
  class: "modal-title",
  id: "showPojectLabel"
}
const _hoisted_285 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_286 = { class: "modal-body" }
const _hoisted_287 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_288 = { class: "modal-footer" }
const _hoisted_289 = { class: "modal-wrap default-modal" }
const _hoisted_290 = {
  class: "modal fade",
  id: "addCompanyInfo",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_291 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_292 = { class: "modal-content" }
const _hoisted_293 = { class: "modal-header" }
const _hoisted_294 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_295 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_296 = { class: "modal-body" }
const _hoisted_297 = { class: "row" }
const _hoisted_298 = { class: "col-md-12" }
const _hoisted_299 = {
  key: 0,
  class: "form-group"
}
const _hoisted_300 = { for: "" }
const _hoisted_301 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_302 = { class: "form-group" }
const _hoisted_303 = { for: "" }
const _hoisted_304 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_305 = { class: "form-group" }
const _hoisted_306 = { for: "" }
const _hoisted_307 = { class: "form-group" }
const _hoisted_308 = { for: "" }
const _hoisted_309 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_310 = { class: "custom-file" }
const _hoisted_311 = { class: "upload-btn-wrapper" }
const _hoisted_312 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_313 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_314 = { class: "form-group" }
const _hoisted_315 = { for: "" }
const _hoisted_316 = { class: "form-group" }
const _hoisted_317 = { for: "" }
const _hoisted_318 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_SendSmartContractAddPhaseModal = _resolveComponent("SendSmartContractAddPhaseModal")
  const _component_Editor = _resolveComponent("Editor")
  const _component_AppDeleteConfirmationModal = _resolveComponent("AppDeleteConfirmationModal")
  const _component_SignaturePadModal = _resolveComponent("SignaturePadModal")
  const _component_SignatureUploadModal = _resolveComponent("SignatureUploadModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (_ctx.state.ui.isLoading.loadDetailsData ||
      _ctx.state.ui.isLoading.getSmartContractDetails
    )
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('send_smart_contract')), 1),
              _createVNode("div", _hoisted_7, [
                _createVNode("nav", _hoisted_8, [
                  _createVNode("ol", _hoisted_9, [
                    _hoisted_10,
                    _createVNode("li", _hoisted_11, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToProjectToDo && _ctx.redirectToProjectToDo(...args)))
                      }, _toDisplayString(_ctx.state.data.projectEstimations.name), 1)
                    ]),
                    _createVNode("li", _hoisted_12, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToSmartContractDashboard && _ctx.redirectToSmartContractDashboard(...args)))
                      }, _toDisplayString(_ctx.$t('smart_contract')), 1)
                    ]),
                    _createVNode("li", _hoisted_13, [
                      _createVNode("a", _hoisted_14, _toDisplayString(_ctx.$t('send')), 1)
                    ]),
                    (_ctx.state.data.estimation.title && _ctx.state.data.estimation)
                      ? (_openBlock(), _createBlock("li", _hoisted_15, [
                          _createVNode("a", _hoisted_16, _toDisplayString(_ctx.state.data.estimation.title), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn outline d-inline-block",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.redirectToProjectToDo && _ctx.redirectToProjectToDo(...args)))
                }, [
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode(_component_ErrorList, {
            errors: _ctx.state.ui.errors.errorList.approval,
            hasError: _ctx.state.ui.errors.hasError
          }, null, 8, ["errors", "hasError"]),
          (_ctx.state.data.estimation.title && _ctx.state.data.estimation)
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _createVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('smart_contract_name')), 1),
                    _withDirectives(_createVNode("input", {
                      disabled: "",
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.estimation.title = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.estimation.title]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('project_name')), 1),
                _withDirectives(_createVNode("input", {
                  disabled: "",
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.projectEstimations.name = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectEstimations.name]
                ])
              ]),
              _createVNode("div", _hoisted_29, [
                _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('total_project_estimation')), 1),
                _createVNode("div", _hoisted_31, _toDisplayString(_ctx.usdPriceFormate(_ctx.state.data.projectEstimations.estimatedBudget, null)), 1)
              ])
            ]),
            _createVNode("div", _hoisted_32, [
              _createVNode("div", _hoisted_33, [
                _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('project_details')), 1),
                _withDirectives(_createVNode("textarea", {
                  disabled: "",
                  class: "form-control",
                  rows: "6",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.projectEstimations.description = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectEstimations.description]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_35, [
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _createVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('project_start_date')), 1),
                _createVNode(_component_v_date_picker, {
                  modelValue: _ctx.state.data.projectEstimations.startDate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.projectEstimations.startDate = $event)),
                  "min-date": _ctx.state.data.todayData
                }, {
                  default: _withCtx(({ inputValue, inputEvents }) => [
                    _createVNode("input", _mergeProps({
                      class: _ctx.state.ui.isLoading.projectStartDate
                    ? 'form-control error-field'
                    : 'form-control'
                    ,
                      value: inputValue
                    }, _toHandlers(inputEvents), {
                      placeholder: _ctx.$t('select_start_date')
                    }), null, 16, ["value", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "min-date"])
              ])
            ]),
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, [
                _createVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('project_end_date')), 1),
                _createVNode(_component_v_date_picker, {
                  modelValue: _ctx.state.data.projectEstimations.endDate,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.projectEstimations.endDate = $event)),
                  "min-date": _ctx.state.data.projectEstimations.startDate,
                  class: !_ctx.state.data.projectEstimations.startDate ? 'disabled' : ''
                  
                }, {
                  default: _withCtx(({ inputValue, inputEvents }) => [
                    _createVNode("input", _mergeProps({
                      disabled: !_ctx.state.data.projectEstimations.startDate,
                      class: _ctx.state.ui.isLoading.projectEndDate
                    ? 'form-control error-field'
                    : 'form-control'
                    ,
                      value: inputValue
                    }, _toHandlers(inputEvents), {
                      placeholder: _ctx.$t('select_end_date')
                    }), null, 16, ["disabled", "value", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "min-date", "class"])
              ])
            ])
          ]),
          (_ctx.state.data.isActiveEdocLink)
            ? (_openBlock(), _createBlock("div", _hoisted_42, [
                _createVNode("p", null, _toDisplayString(_ctx.$t('or')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.data.isActiveEdocLink)
            ? (_openBlock(), _createBlock("div", _hoisted_43, [
                _createVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('edoc_link')), 1),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.projectEstimations.edocLink = $event)),
                  placeholder: "https://qa.convorally.com"
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectEstimations.edocLink]
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_45, [
            _createVNode("button", {
              type: "submit",
              disabled: _ctx.hasValidIds,
              class: "btn default-btn d-inline-block mr-2",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showAddPhaseModal && _ctx.showAddPhaseModal(...args)))
            }, _toDisplayString(_ctx.$t('add_phase')), 9, ["disabled"]),
            (_ctx.state.ui.isLoading.projectStartDate &&
            _ctx.state.ui.isLoading.projectEndDate
          )
              ? (_openBlock(), _createBlock("label", _hoisted_46, [
                  _createVNode("span", _hoisted_47, _toDisplayString(_ctx.$t('project_start_end_date_required')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.state.data.createPhase.length > 0)
            ? (_openBlock(), _createBlock("p", _hoisted_48, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('phases')), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.createPhase, (phase, phaseIndex) => {
            return (_openBlock(), _createBlock("div", {
              class: "border p-3 rounded my-2",
              key: phaseIndex
            }, [
              _createVNode("div", _hoisted_49, [
                _createVNode("div", _hoisted_50, [
                  _createVNode("div", _hoisted_51, [
                    _createVNode("label", _hoisted_52, _toDisplayString(phase.name), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_53, [
                  _createVNode("div", _hoisted_54, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn btn-sm text-primary mr-2",
                      title: _ctx.$t('edit'),
                      onClick: ($event: any) => (_ctx.editNewPhase(phase, phaseIndex))
                    }, [
                      _hoisted_55,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                    ], 8, ["title", "onClick"]),
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn btn-sm text-danger",
                      title: "delete",
                      onClick: ($event: any) => (_ctx.selectForDeletePhase(phase))
                    }, [
                      _hoisted_56,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                    ], 8, ["onClick"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_57, [
                _createVNode("div", _hoisted_58, [
                  _createVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createVNode("div", _hoisted_61, [
                      _createVNode("p", null, _toDisplayString(_ctx.$t('estimation')), 1),
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.usdPriceFormate(phase.budget, null)), 1)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_62, [
                  _createVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _createVNode("div", _hoisted_65, [
                      _createVNode("p", null, _toDisplayString(_ctx.$t('start_date')), 1),
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(phase.startDate), 1)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_66, [
                  _createVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode("div", _hoisted_69, [
                      _createVNode("p", null, _toDisplayString(_ctx.$t('end_date')), 1),
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(phase.endDate), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_70, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_description')) + " : ", 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("small", null, _toDisplayString(phase.description), 1)
                ])
              ]),
              (phase.child_phases || phase.tasks)
                ? (_openBlock(), _createBlock("div", _hoisted_71, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.child_phases ||
              phase.groupTasks, (task, taskIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "mb-3 border-bottom pb-3",
                        key: taskIndex
                      }, [
                        _createVNode("div", _hoisted_72, [
                          _createVNode("div", _hoisted_73, [
                            _createVNode("div", _hoisted_74, [
                              _createVNode("label", {
                                for: "",
                                title: _ctx.$t('phase_name')
                              }, _toDisplayString(task.name), 9, ["title"])
                            ])
                          ]),
                          (task.allMembers)
                            ? (_openBlock(), _createBlock("div", _hoisted_75, [
                                _createVNode("div", _hoisted_76, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.allMembers, (user, userIndex) => {
                                    return (_openBlock(), _createBlock("a", {
                                      href: "javascript:void(0)",
                                      key: userIndex
                                    }, [
                                      _createVNode("span", null, [
                                        _createVNode("img", {
                                          src: user.image
                          ? user.image
                          : `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                          ,
                                          alt: "user.email",
                                          title: user.email
                                        }, null, 8, ["src", "title"])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_77, [
                          (task.budget)
                            ? (_openBlock(), _createBlock("div", _hoisted_78, [
                                _createVNode("div", _hoisted_79, [
                                  _hoisted_80,
                                  _createVNode("div", _hoisted_81, [
                                    _createVNode("p", null, _toDisplayString(_ctx.$t('estimation')), 1),
                                    _createVNode("p", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.usdPriceFormate(task.budget, null)), 1)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_82, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('task_description')) + " :", 1)
                          ]),
                          _createVNode("p", null, [
                            _createVNode("small", null, _toDisplayString(task.description), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_83, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('item_lists')) + " :", 1)
                          ]),
                          ((task.items && task.items.length > 0) ||
                  task.estimation_items
                )
                            ? (_openBlock(), _createBlock("div", _hoisted_84, [
                                _createVNode("div", _hoisted_85, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.estimation_items, (item, itemIndex) => {
                                    return (_openBlock(), _createBlock("div", {
                                      class: "card p-1",
                                      key: itemIndex
                                    }, [
                                      _createVNode("div", {
                                        class: "card-header p-0",
                                        id: `heading${itemIndex}${taskIndex}${item.id}`
                                      }, [
                                        _createVNode("h2", _hoisted_86, [
                                          _createVNode("button", {
                                            class: "btn btn-link text-left shadow-none collapsed",
                                            type: "button",
                                            "data-toggle": "collapse",
                                            "data-target": `#collapse${itemIndex}${taskIndex}${item.id}`,
                                            "aria-expanded": "true",
                                            "aria-controls": "collapseOne"
                                          }, _toDisplayString(item.name), 9, ["data-target"])
                                        ])
                                      ], 8, ["id"]),
                                      _createVNode("div", {
                                        id: `collapse${itemIndex}${taskIndex}${item.id}`,
                                        class: "collapse",
                                        "aria-labelledby": `heading${itemIndex}${taskIndex}${item.id}`,
                                        "data-parent": "#accordionExample"
                                      }, [
                                        _createVNode("div", _hoisted_87, [
                                          _createVNode("div", _hoisted_88, [
                                            _createVNode("div", _hoisted_89, [
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('item_name')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(item.name), 1),
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('item_cost')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(item.cost, null)), 1),
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('quantity')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(item.quantity), 1)
                                            ]),
                                            _createVNode("div", _hoisted_90, [
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('mark_up')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(item.markup, item.markup_type)), 1),
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('item_description')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(item.description), 1)
                                            ])
                                          ])
                                        ])
                                      ], 8, ["id", "aria-labelledby"])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (phase.attachments && phase.attachments.length)
                ? (_openBlock(), _createBlock("div", _hoisted_91, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_attachments')) + " : ", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (phase.attachments && phase.attachments.length)
                ? (_openBlock(), _createBlock("div", _hoisted_92, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.attachments, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-sm-6",
                        key: imageIndex
                      }, [
                        (image.extension === 'jpg' ||
                image.extension === 'png' ||
                image.extension === 'jpeg' ||
                image.extension === 'gif'
              )
                          ? (_openBlock(), _createBlock("div", _hoisted_93, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_94, [
                                    _createVNode("span", _hoisted_95, [
                                      _createVNode("span", _hoisted_96, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedAttachment(phase, image))
                              }, [
                                _hoisted_97
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_98, [
                                _createVNode("div", _hoisted_99, [
                                  _createVNode("img", {
                                    src: image.file,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_100, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'pdf')
                          ? (_openBlock(), _createBlock("div", _hoisted_101, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_102, [
                                    _createVNode("span", _hoisted_103, [
                                      _createVNode("span", _hoisted_104, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedAttachment(image))
                              }, [
                                _hoisted_105
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_106, [
                                _createVNode("div", _hoisted_107, [
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                      ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                      : 'img/pdf.jpg'
                      ,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_108, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'doc' || image.extension === 'docx')
                          ? (_openBlock(), _createBlock("div", _hoisted_109, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_110, [
                                    _createVNode("span", _hoisted_111, [
                                      _createVNode("span", _hoisted_112, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedAttachment(image))
                              }, [
                                _hoisted_113
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_114, [
                                _hoisted_115,
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_116, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'mp4' ||
                image.extension === 'mov' ||
                image.extension === 'MOV' ||
                image.extension === 'wmv' ||
                image.extension === 'webm' ||
                image.extension === 'ogg' ||
                image.extension === 'avi' ||
                image.extension === 'x-ms-wmv'
              )
                          ? (_openBlock(), _createBlock("div", _hoisted_117, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_118, [
                                    _createVNode("div", _hoisted_119, [
                                      _createVNode("span", _hoisted_120, [
                                        _createVNode("span", _hoisted_121, _toDisplayString(_ctx.$t('loading1')), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: _ctx.state.data.imageBaseUrl
                  ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                  : 'img/video-icon.png'
                  ,
                                alt: "",
                                height: "200"
                              }, null, 8, ["src"]),
                              _createVNode("h5", null, _toDisplayString(image.name), 1),
                              _createVNode("p", _hoisted_122, _toDisplayString(image.size), 1),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedAttachment(image))
                              }, [
                                _hoisted_123
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (!(_ctx.state.data.companyInfo.logo || _ctx.state.data.estimation.logo))
            ? (_openBlock(), _createBlock("div", _hoisted_124, [
                _createVNode("a", {
                  "data-toggle": "modal",
                  class: "btn default-btn d-inline-block mr-2",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showCreateCompanyModel && _ctx.showCreateCompanyModel(...args)))
                }, _toDisplayString(_ctx.$t('add_company_information')), 1)
              ]))
            : _createCommentVNode("", true),
          ((_ctx.state.data.companyInfo.acknowledgement &&
          _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.estimation.acknowledgement &&
            _ctx.state.data.estimation.legal_statement)
        )
            ? (_openBlock(), _createBlock("p", _hoisted_125, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('company_contract_preview')), 1)
              ]))
            : _createCommentVNode("", true),
          ((_ctx.state.data.companyInfo.acknowledgement &&
          _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.estimation.acknowledgement &&
            _ctx.state.data.estimation.legal_statement)
        )
            ? (_openBlock(), _createBlock("div", _hoisted_126, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')), 1),
                  _createVNode("a", {
                    class: "btn default-btn btn-sm ms-2",
                    title: _ctx.$t('edit'),
                    href: "javascript:void(0)",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.editCompany && _ctx.editCompany(...args)))
                  }, [
                    _hoisted_127,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                  ], 8, ["title"])
                ]),
                (_ctx.state.data.companyInfo.logo || _ctx.state.data.estimation.logo)
                  ? (_openBlock(), _createBlock("div", _hoisted_128, [
                      ((_ctx.state.data.companyInfo.logo && _ctx.state.data.companyInfo.logo.file) || (_ctx.state.data.estimation.logo && _ctx.state.data.estimation.logo.file)
            )
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            class: "rounded",
                            src: (_ctx.state.data.companyInfo.logo.file || _ctx.state.data.estimation.logo.file)
              ? (_ctx.state.data.companyInfo.logo.file || _ctx.state.data.estimation.logo.file)
              : (_ctx.state.data.companyInfo.logo || _ctx.state.data.estimation.logo)
              ,
                            alt: ""
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock("img", {
                            key: 1,
                            class: "rounded",
                            src: _ctx.state.data.companyInfo.logo || _ctx.state.data.estimation.logo,
                            alt: ""
                          }, null, 8, ["src"]))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_129, [
                  _createVNode("ul", _hoisted_130, [
                    _createVNode("li", _hoisted_131, [
                      _createVNode("button", _hoisted_132, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                    ]),
                    _createVNode("li", _hoisted_133, [
                      _createVNode("button", _hoisted_134, _toDisplayString(_ctx.$t('legal_statement')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_135, [
                    _createVNode("div", _hoisted_136, [
                      _createVNode("div", {
                        innerHTML: _ctx.state.data.estimation?.acknowledgement || _ctx.state.data.companyInfo.acknowledgement
                      }, null, 8, ["innerHTML"])
                    ]),
                    _createVNode("div", _hoisted_137, [
                      _createVNode("div", {
                        innerHTML: _ctx.state.data.estimation?.legal_statement || _ctx.state.data.companyInfo.legal_statement
                      }, null, 8, ["innerHTML"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_138, [
            _createVNode("ul", null, [
              (!_ctx.state.ui.isLoading.signaturePadLoad && _ctx.state.data.sendarSignature)
                ? (_openBlock(), _createBlock("li", _hoisted_139, [
                    _createVNode("label", _hoisted_140, [
                      _createTextVNode(_toDisplayString(_ctx.$t('signature')) + " ", 1),
                      _hoisted_141
                    ]),
                    (_ctx.state.data.sendarSignature)
                      ? (_openBlock(), _createBlock("div", _hoisted_142, [
                          _createVNode("img", {
                            src: _ctx.state.data.sendarSignature,
                            alt: ""
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("button", {
                      for: "formFileSm",
                      class: "btn default-btn mr-2",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.enableSignaturPad && _ctx.enableSignaturPad(...args)))
                    }, _toDisplayString(_ctx.$t('add_new_signature')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("li", {
                class: !_ctx.state.ui.isLoading.signaturePadLoad && _ctx.state.data.sendarSignature ? 'd-none' : ''
              }, [
                _createVNode("div", _hoisted_143, [
                  _createVNode("div", null, [
                    (_ctx.state.data.cropSignature)
                      ? (_openBlock(), _createBlock("div", _hoisted_144, [
                          _createVNode("img", {
                            src: _ctx.state.data.cropSignature,
                            alt: ""
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_145, [
                  _createVNode("div", _hoisted_146, [
                    _createVNode("ul", null, [
                      _createVNode("li", null, [
                        _createVNode("div", _hoisted_147, [
                          _createVNode("button", _hoisted_148, [
                            _hoisted_149,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('upload_signature')), 1)
                          ]),
                          _createVNode("input", {
                            type: "file",
                            accept: "image/png, image/jpeg",
                            id: "profileUpdate",
                            onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.uploadSignatureFile($event)))
                          }, null, 32)
                        ])
                      ]),
                      _createVNode("li", null, [
                        _createVNode("button", {
                          class: "btn default-btn",
                          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.showSignaturePad && _ctx.showSignaturePad(...args)))
                        }, [
                          _hoisted_150,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('draw_signature')), 1)
                        ])
                      ]),
                      (_ctx.state.data.haveProfileSign)
                        ? (_openBlock(), _createBlock("li", _hoisted_151, [
                            _createVNode("div", _hoisted_152, [
                              _createVNode("button", {
                                for: "formFileSm",
                                class: "btn default-btn mr-2",
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.userSignature('use')))
                              }, [
                                _hoisted_153,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('use_profile_signature')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("li", null, [
                        _createVNode("button", {
                          class: "btn red-btn",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.clearSignature()))
                        }, _toDisplayString(_ctx.$t('clear')), 1)
                      ])
                    ])
                  ])
                ])
              ], 2)
            ])
          ]),
          _createVNode("div", _hoisted_154, [
            _createVNode("label", _hoisted_155, _toDisplayString(_ctx.$t('attachments_docs')), 1),
            _createVNode(_component_DragAndDropZone, {
              onDrop: _withModifiers(_ctx.dropFiles, ["prevent"]),
              onDropFiles: _ctx.dropFiles
            }, null, 8, ["onDrop", "onDropFiles"]),
            (_ctx.state.data.projectEstimations.attachments &&
            _ctx.state.data.projectEstimations.attachments.length
          )
              ? (_openBlock(), _createBlock("div", _hoisted_156, [
                  _createVNode("div", _hoisted_157, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectEstimations
                .attachments, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-sm-6",
                        key: imageIndex
                      }, [
                        (image.file_type === 'jpg' ||
                  image.file_type === 'png' ||
                  image.file_type === 'jpeg' ||
                  image.file_type === 'gif'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_158, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_159, [
                                    _createVNode("span", _hoisted_160, [
                                      _createVNode("span", _hoisted_161, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeUploadSelectedImage(image))
                              }, [
                                _hoisted_162
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_163, [
                                _createVNode("div", _hoisted_164, [
                                  _createVNode("img", {
                                    src: image.file_link,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'pdf')
                          ? (_openBlock(), _createBlock("div", _hoisted_165, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_166, [
                                    _createVNode("span", _hoisted_167, [
                                      _createVNode("span", _hoisted_168, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeUploadSelectedImage(image))
                              }, [
                                _hoisted_169
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_170, [
                                _createVNode("div", _hoisted_171, [
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                        ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                        : 'img/pdf.jpg'
                        ,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'doc' || image.file_type === 'docx')
                          ? (_openBlock(), _createBlock("div", _hoisted_172, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_173, [
                                    _createVNode("span", _hoisted_174, [
                                      _createVNode("span", _hoisted_175, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_176
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_177, [
                                _hoisted_178,
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'mp4' ||
                  image.file_type === 'mov' ||
                  image.file_type === 'MOV' ||
                  image.file_type === 'wmv' ||
                  image.file_type === 'webm' ||
                  image.file_type === 'ogg' ||
                  image.file_type === 'avi' ||
                  image.file_type === 'x-ms-wmv'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_179, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_180, [
                                    _createVNode("div", _hoisted_181, [
                                      _createVNode("span", _hoisted_182, [
                                        _createVNode("span", _hoisted_183, _toDisplayString(_ctx.$t('loading1')), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                    : 'img/video-icon.png'
                    ,
                                alt: "",
                                height: "200"
                              }, null, 8, ["src"]),
                              _createVNode("h5", null, _toDisplayString(image.file_name), 1),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeUploadSelectedImage(image))
                              }, [
                                _hoisted_184
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectEstimations
                .attachments, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-sm-6",
                        key: imageIndex
                      }, [
                        (image.extension === 'jpg' ||
                  image.extension === 'png' ||
                  image.extension === 'jpeg' ||
                  image.extension === 'gif'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_185, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_186, [
                                    _createVNode("span", _hoisted_187, [
                                      _createVNode("span", _hoisted_188, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_189
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_190, [
                                _createVNode("div", _hoisted_191, [
                                  _createVNode("img", {
                                    src: image.file,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_192, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'pdf')
                          ? (_openBlock(), _createBlock("div", _hoisted_193, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_194, [
                                    _createVNode("span", _hoisted_195, [
                                      _createVNode("span", _hoisted_196, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_197
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_198, [
                                _createVNode("div", _hoisted_199, [
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                        ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                        : 'img/pdf.jpg'
                        ,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_200, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'doc' || image.extension === 'docx')
                          ? (_openBlock(), _createBlock("div", _hoisted_201, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_202, [
                                    _createVNode("span", _hoisted_203, [
                                      _createVNode("span", _hoisted_204, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_205
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_206, [
                                _hoisted_207,
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_208, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'mp4' ||
                  image.extension === 'mov' ||
                  image.extension === 'MOV' ||
                  image.extension === 'wmv' ||
                  image.extension === 'webm' ||
                  image.extension === 'ogg' ||
                  image.extension === 'avi' ||
                  image.extension === 'x-ms-wmv'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_209, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_210, [
                                    _createVNode("div", _hoisted_211, [
                                      _createVNode("span", _hoisted_212, [
                                        _createVNode("span", _hoisted_213, _toDisplayString(_ctx.$t('loading1')), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                    : 'img/video-icon.png'
                    ,
                                alt: "",
                                height: "200"
                              }, null, 8, ["src"]),
                              _createVNode("h5", null, _toDisplayString(image.name), 1),
                              _createVNode("p", _hoisted_214, _toDisplayString(image.size), 1),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_215
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_216, [
            (_ctx.state.data.selectedCustomers.length)
              ? (_openBlock(), _createBlock("div", _hoisted_217, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedCustomers, (customer, customerIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "col-md-4 col-sm-6 mb-2 px-2",
                      key: customerIndex
                    }, [
                      (customer.isEdit)
                        ? (_openBlock(), _createBlock("div", _hoisted_218, [
                            _createVNode("div", _hoisted_219, [
                              _createVNode("div", _hoisted_220, [
                                _createVNode("div", _hoisted_221, [
                                  _createVNode("label", _hoisted_222, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('enter_email_address')), 1)
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    disabled: "",
                                    class: customer.emailError
                        ? 'form-control error-field'
                        : 'form-control'
                        ,
                                    "onUpdate:modelValue": ($event: any) => (customer.email = $event)
                                  }, null, 10, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.email]
                                  ]),
                                  _createVNode("p", _hoisted_223, _toDisplayString(customer.emailError), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_224, [
                                _createVNode("div", _hoisted_225, [
                                  _createVNode("label", _hoisted_226, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('first_name')), 1)
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.first_name = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.first_name]
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_227, [
                                _createVNode("div", _hoisted_228, [
                                  _createVNode("label", _hoisted_229, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('last_name')), 1)
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.last_name = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.last_name]
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_230, [
                                _createVNode("div", _hoisted_231, [
                                  _createVNode("label", _hoisted_232, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('phone_number')), 1)
                                  ]),
                                  _createVNode("div", _hoisted_233, [
                                    _hoisted_234,
                                    _withDirectives(_createVNode("input", {
                                      type: "number",
                                      class: customer.phoneError ? 'form-control error-field' : 'form-control',
                                      placeholder: _ctx.$t('mobile_number_only'),
                                      "onUpdate:modelValue": ($event: any) => (customer.phone = $event)
                                    }, null, 10, ["placeholder", "onUpdate:modelValue"]), [
                                      [_vModelText, customer.phone]
                                    ]),
                                    _createVNode("p", _hoisted_235, _toDisplayString(customer.phoneError), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_236, [
                                _createVNode("div", _hoisted_237, [
                                  _createVNode("label", _hoisted_238, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('notify_by')), 1)
                                  ]),
                                  _createVNode("div", _hoisted_239, [
                                    _createVNode("div", _hoisted_240, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: "inlineCheckbox1",
                                        value: "true",
                                        disabled: customer.mailNotification,
                                        "onUpdate:modelValue": ($event: any) => (customer.mailNotification = $event)
                                      }, null, 8, ["disabled", "onUpdate:modelValue"]), [
                                        [_vModelCheckbox, customer.mailNotification]
                                      ]),
                                      _createVNode("label", _hoisted_241, _toDisplayString(_ctx.$t('email')), 1)
                                    ]),
                                    _createVNode("div", _hoisted_242, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: "inlineCheckbox2",
                                        value: "true",
                                        "onUpdate:modelValue": ($event: any) => (customer.smsNotification = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelCheckbox, customer.smsNotification]
                                      ]),
                                      _createVNode("label", _hoisted_243, _toDisplayString(_ctx.$t('sms')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", _hoisted_244, _toDisplayString(customer.mailNotificationError), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_245, [
                                _createVNode("div", _hoisted_246, [
                                  _createVNode("label", _hoisted_247, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('address')), 1)
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.address_line1 = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.address_line1]
                                  ])
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_248, [
                              _createVNode("a", {
                                class: "btn default-btn btn-sm",
                                title: _ctx.$t('update'),
                                href: "javascript:void(\n                              0)",
                                onClick: ($event: any) => (_ctx.updateSelectCustomer(customerIndex))
                              }, [
                                _hoisted_249,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('update')), 1)
                              ], 8, ["title", "onClick"])
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_250, [
                            _createVNode("div", _hoisted_251, [
                              _createVNode("a", {
                                class: "btn default-btn btn-sm mr-2",
                                title: _ctx.$t('edit'),
                                href: "javascript:void(\n                              0)",
                                onClick: ($event: any) => (_ctx.editSelectCustomer(customerIndex))
                              }, [
                                _hoisted_252,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                              ], 8, ["title", "onClick"]),
                              _createVNode("a", {
                                class: "btn btn-sm red-btn",
                                title: "Delete",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.showDelete(customer))
                              }, [
                                _hoisted_253,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                              ], 8, ["onClick"])
                            ]),
                            _createVNode("div", _hoisted_254, [
                              _createVNode("div", _hoisted_255, [
                                _createVNode("div", _hoisted_256, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('enter_email_address')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.email), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_257, [
                                _createVNode("div", _hoisted_258, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('first_name')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.first_name), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_259, [
                                _createVNode("div", _hoisted_260, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('last_name')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.last_name), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_261, [
                                _createVNode("div", _hoisted_262, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_number')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.phone), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_263, [
                                _createVNode("div", _hoisted_264, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('notify_by')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    (customer.mailNotification)
                                      ? (_openBlock(), _createBlock("small", _hoisted_265, _toDisplayString(_ctx.$t('mail')), 1))
                                      : _createCommentVNode("", true),
                                    _hoisted_266,
                                    (customer.smsNotification)
                                      ? (_openBlock(), _createBlock("small", _hoisted_267, _toDisplayString(_ctx.$t('sms')), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_268, [
                                _createVNode("div", _hoisted_269, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('address')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.address_line1), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_270, [
                  _hoisted_271,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('customer_does_not_selected')) + " " + _toDisplayString(_ctx.$t('please_select_or_add_customer_email')), 1)
                ]))
          ]),
          _createVNode("div", _hoisted_272, [
            _createVNode("label", _hoisted_273, _toDisplayString(_ctx.$t('customer_emails')), 1),
            _createVNode(_component_multiselect, {
              modelValue: _ctx.state.data.selectedCustomers,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.data.selectedCustomers = $event)),
              "tag-placeholder": "Select or add customer email",
              placeholder: _ctx.$t('select_or_add_customer_email'),
              label: "code",
              "track-by": "code",
              options: _ctx.state.data.allCustomer,
              multiple: true,
              taggable: true,
              onTag: _ctx.addCustomerEmail,
              onSelect: _ctx.changeValue
            }, null, 8, ["modelValue", "placeholder", "options", "onTag", "onSelect"]),
            _withDirectives(_createVNode("p", { class: "text-red" }, _toDisplayString(_ctx.$t('please_add_valid_email_only')), 513), [
              [_vShow, _ctx.isInvalid]
            ])
          ]),
          (_ctx.state.data.selectedCustomers.length >= 2)
            ? (_openBlock(), _createBlock("div", _hoisted_274, [
                _withDirectives(_createVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.data.approveByAll = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.state.data.approveByAll]
                ]),
                _createVNode("label", {
                  for: "Approve By All Members",
                  title: _ctx.$t('approve_by_all_members')
                }, _toDisplayString(_ctx.$t('approve_by_all_members')), 9, ["title"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_275, [
            _withDirectives(_createVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.state.data.individualAcceptance = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.state.data.individualAcceptance]
            ]),
            _createVNode("label", {
              for: "Is Individual Phase Accept Required",
              title: _ctx.$t('is_individual_phase_accept_required')
            }, _toDisplayString(_ctx.$t('is_individual_phase_accept_required')), 9, ["title"])
          ]),
          _createVNode("div", _hoisted_276, [
            _createVNode("button", {
              type: "submit",
              class: "btn default-btn d-inline-block mr-2",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sendInvitationEstimation(0))),
              disabled: _ctx.state.ui.isPostLoading.saveEstimation
            }, _toDisplayString(_ctx.state.ui.isPostLoading.saveEstimation ? _ctx.$t('loading1') : _ctx.$t('save')), 9, ["disabled"]),
            _createVNode("button", {
              type: "submit",
              class: "btn default-btn d-inline-block mr-2",
              disabled: _ctx.iActiveValidation,
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.sendInvitationEstimation(1)))
            }, _toDisplayString(_ctx.state.ui.isPostLoading.sendEstimation ? _ctx.$t('loading1') : _ctx.$t('send')), 9, ["disabled"]),
            _createVNode("button", {
              type: "submit",
              class: "btn red-btn d-inline-block",
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.redirectToProjectToDo && _ctx.redirectToProjectToDo(...args)))
            }, _toDisplayString(_ctx.$t('cancel')), 1),
            (_ctx.state.ui.isLoading.isReadyToSend)
              ? (_openBlock(), _createBlock("label", _hoisted_277, [
                  _createVNode("span", _hoisted_278, _toDisplayString(_ctx.$t('some_phase_items_not_selected')) + " " + _toDisplayString(_ctx.$t('please_verify')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.state.data.showSuccesCustomModal)
          ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
              key: 0,
              onClose: _ctx.closeSuccessCustomModal,
              showModal: _ctx.state.data.showSuccesCustomModal,
              titleMessage: _ctx.state.data.successFulMessage
            }, null, 8, ["onClose", "showModal", "titleMessage"]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_279, [
          _createVNode("div", _hoisted_280, [
            _createVNode("div", _hoisted_281, [
              _createVNode("div", _hoisted_282, [
                _createVNode("div", _hoisted_283, [
                  _createVNode("h5", _hoisted_284, _toDisplayString(_ctx.$t('remove')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "modal",
                    onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.hideDelete && _ctx.hideDelete(...args))),
                    "aria-label": "Close"
                  }, [
                    _hoisted_285
                  ])
                ]),
                _createVNode("div", _hoisted_286, [
                  _createVNode("div", _hoisted_287, _toDisplayString(_ctx.$t('are_you_sure_you_want_to_remove')), 1)
                ]),
                _createVNode("div", _hoisted_288, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.removeSelectCustomer(_ctx.state.data.removeUser)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.delete ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn",
                    "data-dismiss": "modal",
                    onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.hideDelete && _ctx.hideDelete(...args)))
                  }, _toDisplayString(_ctx.$t('no')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showAddPhaseModal)
        ? (_openBlock(), _createBlock(_component_SendSmartContractAddPhaseModal, {
            key: 1,
            showAddPhase: _ctx.state.data.showAddPhaseModal,
            editMode: _ctx.state.data.editMode,
            editData: _ctx.state.data.editData,
            projectAcknowledgementDetail: _ctx.state.data.projectEstimations,
            editFrom: _ctx.state.data.editFrom,
            checkData: _ctx.state.data.selectedItemList,
            phases: _ctx.state.data.sendPhases,
            onClose: _ctx.closeAddPhaseModal,
            onReset: _ctx.resetAddPhaseModal,
            onAddPhase: _ctx.addNewPhase,
            onUpdatePhase: _ctx.updatePhase,
            onResetChecked: _ctx.resetChecked,
            onUpdateTask: _ctx.updateTask
          }, null, 8, ["showAddPhase", "editMode", "editData", "projectAcknowledgementDetail", "editFrom", "checkData", "phases", "onClose", "onReset", "onAddPhase", "onUpdatePhase", "onResetChecked", "onUpdateTask"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_289, [
        _createVNode("div", _hoisted_290, [
          _createVNode("div", _hoisted_291, [
            _createVNode("div", _hoisted_292, [
              _createVNode("div", _hoisted_293, [
                _createVNode("h5", _hoisted_294, _toDisplayString(_ctx.$t('add_company_information')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, [
                  _hoisted_295
                ])
              ]),
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.createCompanyIfno,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_296, [
                _createVNode("div", _hoisted_297, [
                  _createVNode("div", _hoisted_298, [
                    (!_ctx.state.ui.isLoading.isCompanyEdit)
                      ? (_openBlock(), _createBlock("div", _hoisted_299, [
                          _createVNode("label", _hoisted_300, _toDisplayString(_ctx.$t('company_name')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.state.data.companyInfo.company_name = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_name]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_301, [
                        _createVNode("div", _hoisted_302, [
                          _createVNode("label", _hoisted_303, _toDisplayString(_ctx.$t('phone_number')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.state.data.companyInfo.company_phone_number = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_phone_number]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_304, [
                        _createVNode("div", _hoisted_305, [
                          _createVNode("label", _hoisted_306, _toDisplayString(_ctx.$t('email_address')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.state.data.companyInfo.company_email = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_email]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_307, [
                  _createVNode("label", _hoisted_308, _toDisplayString(_ctx.$t('company_logo')), 1),
                  (_ctx.state.data.estimation.logo)
                    ? (_openBlock(), _createBlock("div", _hoisted_309, [
                        _createVNode("img", {
                          src: _ctx.state.data.estimation.logo.file
                    ? _ctx.state.data.estimation.logo.file
                    : _ctx.state.data.estimation.logo
                    ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_310, [
                    _createVNode("div", _hoisted_311, [
                      _createVNode("button", _hoisted_312, [
                        _hoisted_313,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('upload')), 1)
                      ]),
                      _createVNode("input", {
                        type: "file",
                        accept: "image/png, image/jpeg",
                        id: "profileUpdate",
                        onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.uploadLogo($event)))
                      }, null, 32)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_314, [
                  _createVNode("label", _hoisted_315, _toDisplayString(_ctx.$t('add_acknowledgement')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.acknowledgement,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.acknowledgement = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_316, [
                  _createVNode("label", _hoisted_317, _toDisplayString(_ctx.$t('add_conduct_of_contract')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.legalStatement,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.legalStatement = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_318, [
                (_ctx.state.ui.isLoading.isCompanyEdit)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                    }, _toDisplayString(_ctx.$t('update')), 1))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.createCompanyIfno && _ctx.createCompanyIfno(...args)))
                    }, _toDisplayString(_ctx.$t('save_changes')), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showDeletePhaseConfirmation)
        ? (_openBlock(), _createBlock(_component_AppDeleteConfirmationModal, {
            key: 2,
            showConfirmationModal: _ctx.state.data.showDeletePhaseConfirmation,
            onButtonTrigger: _ctx.removeSelectedPhase,
            onHideConfirmation: _ctx.hideConfirmation,
            message: _ctx.state.data.deleteModalMessage
          }, null, 8, ["showConfirmationModal", "onButtonTrigger", "onHideConfirmation", "message"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.state.data.showSignaturePad)
      ? (_openBlock(), _createBlock(_component_SignaturePadModal, {
          key: 0,
          onClose: _ctx.hideSignaturePad,
          onUploadSignature: _ctx.uploadSignature,
          showModal: _ctx.state.data.showSignaturePad,
          from: 'estimation'
        }, null, 8, ["onClose", "onUploadSignature", "showModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignatureUpload)
      ? (_openBlock(), _createBlock(_component_SignatureUploadModal, {
          key: 1,
          showModal: _ctx.state.data.showSignatureUpload,
          signatureFile: _ctx.state.data.uploadSignatureFile,
          from: 'estimation',
          onClose: _ctx.hideSignatureUpload,
          onUploadSignature: _ctx.uploadSignature
        }, null, 8, ["showModal", "signatureFile", "onClose", "onUploadSignature"]))
      : _createCommentVNode("", true)
  ], 64))
}